import React, { PropTypes } from 'react';

const NextButton = (props) => {
    const { activeId, pagesList, actions } = props;

    const goToNextPage = () => {
        const redirectToPage = pagesList[pagesList.indexOf(activeId) + 1];
        actions.setActivePage(redirectToPage);
    };

    return (
        <span className="nav-btns__next" onClick={goToNextPage} title="Next">
            { (activeId === 1) ? 'Lets start' : 'Next' }
        </span>
    );
};

NextButton.propTypes = {
    activeId: PropTypes.number.isRequired,
    pagesList: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
};

export default NextButton;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/NavButtons/Next.jsx